import token from 'styled-token';

/** @mixin autofillBackgroundMixin */
/**
 * Adds autofill styling to a component.
 *
 * @example
 * import { autofillBackgroundMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     &:-webkit-autofill {
 *          ${autofillBackgroundMixin};
 *      }
 * `;
 *
 * <Component>My component with autofill atyling</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var autofillBackgroundMixin = function autofillBackgroundMixin(props) {
  return "\n    box-shadow: 0 0 0 1000px " + (token('Input.backgroundColorAutofill')(props) || '') + " inset;\n";
};